import { Locales } from '@griply/types';
import { filterLifeAreasBySearchText } from '@griply/utils';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';

export const useTextFilteredLifeAreas = (
  searchText: string,
  locale: Locales,
) => {
  const lifeAreas = useLocalizedLifeAreas();

  return useMemo(
    () => filterLifeAreasBySearchText(lifeAreas, searchText, locale),
    [lifeAreas, searchText, locale],
  );
};
